// Wordpress PHP Functions
import './functions.php';             // Main wordpress template functions
import './style.css';

// Template Styles
import './style.scss';                // Main Style file for our template

// Template Overrides
import './header.php';
import './header/header-version2.php';
import './header/header-version3.php';
import './ovaem-templates/loop/ticket.php';
import './ovaem-templates/archive-event.php';
import './ovaem-templates/single-event-modern.php';
import './widgets/ovaem-categories-sub.php';
import './widgets/category-walker.php'
import './extend/breadcrumbs.php';

// Language Files
import './languages/de_DE.mo';
import './languages/de_DE.po';

jQuery(document).ready(() => {
  // Rewrite buttons with href "#anfragen"
  var button = jQuery('a[href="#anfragen"]');

  button.attr('target', '_self');
  button.attr('href', 'javascript:void(0)');

  button.on('click', function(){
    (jQuery('#event_tab a[href="#event_contact"]') as any).tab('show');
  });

  // Make Divider in Mega Menu
  var dividers = jQuery('a[href="#custom-divider"]');

  dividers.addClass('custom-divider');
  dividers.html('');
});
